export default "/app/a01e3f2d6c83dc3aee175e2482b3f777.eot";